// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import Sidebar from "./sidebar";
// import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

// import languageLogo from '../assets/Icons/language-icon-matrimony.png';
// import PreferenceEditIcon from '../assets/Icons/edit-icon.svg';
// import { useNavigate } from "react-router";

// const ProfilePage = () => {
//   const navigate = useNavigate();
//   const [language, setLanguage] = useState("en");
//   const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);

//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);

//   const [userProfile, setUserProfile] = useState(null);
//   const [loadingUserProfile, setLoadingUserProfile] = useState(true);

//   const [openPreferenceEditForm, setOpenPreferenceEditForm] = useState(false);
//   const [formData, setFormData] = useState(null);

//   // Fetch user Profile
//   const fetchUserProfile = async () => {
//     setLoadingUserProfile(true);
//     try {
//       const token = localStorage.getItem("authToken");

//       const response = await fetch(
//         `https://backend.newbrindha.com/matrimony/my_profiles`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (response.status === 401) {
//         localStorage.removeItem("authToken");
//         return;
//       }

//       if (!response.ok) {
//         throw new Error("Failed to fetch profiles");
//       }

//       const data = await response.json();
//       setUserProfile(data.profile);
//     } catch (error) {
//       console.log(error.message);
//     } finally {
//       setLoadingUserProfile(false);
//     }
//   };

//   // Updating Partner Preferences
//   const handleUpdatePartnerPreferences = async (e) => {
//     e.preventDefault();
//     try {
//       const token = localStorage.getItem("authToken");

//       const response = await fetch(
//         `https://backend.newbrindha.com/matrimony/my_profiles`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify(formData)
//         }
//       );

//       if (response.status === 401) {
//         localStorage.removeItem("authToken");
//         return;
//       }

//       const updatedData = await response.json();
//       setUserProfile(prev => ({ ...prev, ...updatedData }));
//       setOpenPreferenceEditForm(false);

//       if (!response.ok) {
//         throw new Error("Failed to update preferences");
//       }
//     } catch (error) {
//       console.log(error.message);
//     }
//   }

//   // Fetch Partner Preferences values for Form
//   useEffect(() => {
//     if (userProfile) {
//       setFormData({
//         "preferred_age_min": userProfile.preferred_age_min || "",
//         "preferred_age_max": userProfile.preferred_age_max || "",
//         "preferred_height_min": userProfile.preferred_height_min || "",
//         "preferred_height_max": userProfile.preferred_height_max || "",
//         "preferred_religion": userProfile.preferred_religion || "",
//         "preferred_caste": userProfile.preferred_caste || "",
//         "preferred_nakshatra": userProfile.preferred_nakshatra || "",
//         "preferred_rashi": userProfile.preferred_rashi || "",
//         "preferred_location": userProfile.preferred_location || "",
//         "preferred_work_status": userProfile.preferred_work_status || ""
//       });
//     }
//   }, [userProfile]);

//   const handleChangeInputValue = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   }

//   useEffect(() => {
//     fetchUserProfile();

//     const checkMobile = () => {
//       setIsMobile(window.innerWidth < 1024);
//       if (window.innerWidth >= 1024) {
//         setIsSidebarOpen(true);
//       } else {
//         setIsSidebarOpen(false);
//       }
//     };

//     checkMobile();
//     window.addEventListener("resize", checkMobile);
//     return () => window.removeEventListener("resize", checkMobile);
//   }, []);

//   // Handle sidebar overlay click
//   const handleOverlayClick = () => {
//     if (isMobile) {
//       setIsSidebarOpen(false);
//     }
//   };

//   // Toggle Language Dropdown
//   const toggleLanguageDropdown = () => {
//     setShowLanguageDropdown((prev) => !prev);
//   };

//   // Change Language
//   const handleLanguageChange = (lang) => {
//     setLanguage(lang);
//     setShowLanguageDropdown(false);
//   };

//   // Close language dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (showLanguageDropdown && !event.target.closest(".language-dropdown")) {
//         setShowLanguageDropdown(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [showLanguageDropdown]);

//   // New animations
//   const fadeIn = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: { duration: 0.5, ease: "easeOut" }
//     }
//   };

//   const slideUp = {
//     hidden: { y: 20, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: { duration: 0.5, ease: "easeOut" }
//     }
//   };

//   const cardHover = {
//     hover: {
//       y: -5,
//       boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
//       transition: { duration: 0.3, ease: "easeOut" }
//     }
//   };

//   const inputHover = {
//     hover: {
//       borderColor: "#FF8350",
//       transition: { duration: 0.2 }
//     },
//     focus: {
//       borderColor: "#FF8350",
//       boxShadow: "0 0 0 2px rgba(255, 131, 80, 0.2)",
//       transition: { duration: 0.2 }
//     }
//   };

//   return (
//     <div className="flex min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 font-poppins overflow-hidden relative">
//       {/* Overlay for mobile when sidebar is open */}
//       <AnimatePresence>
//         {isMobile && isSidebarOpen && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 0.5 }}
//             exit={{ opacity: 0 }}
//             onClick={handleOverlayClick}
//             className="fixed inset-0 bg-black z-30 lg:hidden"
//           />
//         )}
//       </AnimatePresence>

//       {/* Sidebar */}
//       <motion.div
//         initial={{ x: "-100%" }}
//         animate={{ x: isSidebarOpen ? 0 : "-100%" }}
//         transition={{ type: "spring", stiffness: 300, damping: 30 }}
//         className="fixed top-0 left-0 h-full w-64 bg-gray-800 z-40 shadow-xl"
//       >
//         <Sidebar
//           isSidebarOpen={isSidebarOpen}
//           setIsSidebarOpen={setIsSidebarOpen}
//           language={language}
//           translations={{
//             en: {
//               dashboard: "Dashboard",
//               home: "Home",
//               myprofile: "My Profile",
//               inbox: "Inbox",
//               favorites: "Favorites",
//               settings: "Settings",
//               logout: "Logout",
//             },
//             tamil: {
//               dashboard: "டாஷ்போர்டு",
//               home: "முகப்பு",
//               myprofile: "சுயவிவரம்",
//               inbox: "இன்பாக்ஸ்",
//               favorites: "பிடித்தவை",
//               settings: "அமைப்புகள்",
//               logout: "வெளியேறு",
//             },
//           }}
//         />
//       </motion.div>

//       {/* Main Content */}
//       <div className={`flex-1 transition-all duration-300 ${isSidebarOpen ? "lg:ml-64" : "ml-0"}`}>
//         {/* Navbar */}
//         <motion.nav
//           initial={{ y: -100 }}
//           animate={{ y: 0 }}
//           transition={{ duration: 0.5 }}
//           className="fixed top-0 right-0 left-0 bg-[#FF8350] z-20 shadow-md"
//         >
//           <div className="flex justify-between items-center p-4">
//             <div className="flex items-center space-x-4">
//               <button
//                 onClick={() => setIsSidebarOpen(!isSidebarOpen)}
//                 className="text-white hover:text-gray-200 transition-colors lg:hidden"
//                 aria-label="Toggle Menu"
//               >
//                 <Bars3Icon className="h-6 w-6" />
//               </button>
//               <h1 className="text-xl sm:text-2xl font-bold text-white">
//                 My Profile
//               </h1>
//             </div>

//             {/* Language Button */}
//             <div className="relative language-dropdown">
//               <button
//                 onClick={toggleLanguageDropdown}
//                 className="bg-white text-[#d35400] p-1.5 sm:p-2 rounded-full font-medium border border-[#f39c12] hover:bg-[#f39c12] hover:text-white focus:outline-none transition-all duration-150 shadow-md"
//                 aria-label="Change Language"
//               >
//                 <img src={languageLogo} alt="language-logo" className="w-6 h-6" />
//               </button>

//               {/* Language Dropdown */}
//               <AnimatePresence>
//                 {showLanguageDropdown && (
//                   <motion.div
//                     initial={{ opacity: 0, y: -10 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     exit={{ opacity: 0, y: -10 }}
//                     className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg border border-[#f39c12]/20 z-50"
//                   >
//                     <button
//                       onClick={() => handleLanguageChange("en")}
//                       className="w-full text-left px-4 py-2 text-[#d35400] hover:bg-[#f39c12] hover:text-white rounded-t-lg transition-colors"
//                     >
//                       English
//                     </button>
//                     <button
//                       onClick={() => handleLanguageChange("tamil")}
//                       className="w-full text-left px-4 py-2 text-[#d35400] hover:bg-[#f39c12] hover:text-white rounded-b-lg transition-colors"
//                     >
//                       தமிழ்
//                     </button>
//                   </motion.div>
//                 )}
//               </AnimatePresence>
//             </div>
//           </div>
//         </motion.nav>

//         {/* Profile Content */}
//         <div className="p-4 sm:p-8 mt-20">
//           {/* Personal Information Card */}
//           <motion.div
//             initial="hidden"
//             animate="visible"
//             variants={fadeIn}
//             whileHover="hover"
//             variants={cardHover}
//             className="bg-white rounded-xl shadow-md mb-6 overflow-hidden"
//           >
//             <div className="p-4 sm:p-6 border-b border-gray-100">
//               <motion.h2
//                 variants={slideUp}
//                 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4 flex items-center"
//               >
//                 <span className="w-2 h-8 bg-[#FF8350] rounded-full mr-3"></span>
//                 About Me
//               </motion.h2>

//               {loadingUserProfile ? (
//                 <motion.p variants={slideUp}>Loading profile...</motion.p>
//               ) : userProfile ? (
//                 <motion.section
//                   variants={fadeIn}
//                   className="flex flex-col w-full h-auto"
//                 >
//                   <div className="flex flex-col md:flex-row gap-6">
//                     <motion.div
//                       whileHover={{ scale: 1.02 }}
//                       className="w-full md:w-1/3 h-64 overflow-hidden rounded-lg shadow-md"
//                     >
//                       <img
//                         src={userProfile.photo_path}
//                         alt={userProfile.full_name}
//                         className="w-full h-full object-cover object-center"
//                       />
//                     </motion.div>

//                     <motion.p
//                       whileHover={{ backgroundColor: "rgba(255, 131, 80, 0.05)" }}
//                       className="flex-1 text-justify px-4 py-4 rounded-lg border border-orange-100 bg-orange-50"
//                     >
//                       Hi there! I'm {userProfile.full_name}, a {userProfile.age} year old {userProfile.occupation?.toLowerCase() || 'professional'}.
//                       I enjoy the little things in life and believe in building meaningful connections.
//                       I'm looking for a partner who shares similar values and aspirations for a happy future together.
//                     </motion.p>
//                   </div>

//                   <motion.h2
//                     variants={slideUp}
//                     className="text-xl sm:text-2xl font-bold text-gray-800 mt-8 mb-4 flex items-center"
//                   >
//                     <span className="w-2 h-8 bg-[#FF8350] rounded-full mr-3"></span>
//                     Personal Information
//                   </motion.h2>

//                   <motion.div
//                     variants={fadeIn}
//                     className="grid sm:grid-cols-2 gap-4"
//                   >
//                     {[
//                       { label: "Matrimony ID", value: userProfile.matrimony_id, colSpan: 2 },
//                       { label: "Name", value: userProfile.full_name },
//                       { label: "Age", value: userProfile.age },
//                       { label: "Email", value: userProfile.email },
//                       { label: "Phone Number", value: userProfile.phone_number },
//                       { label: "Date of Birth", value: userProfile.date_of_birth },
//                       { label: "Gender", value: userProfile.gender },
//                       { label: "Occupation", value: userProfile.occupation },
//                       { label: "Native", value: userProfile.native },
//                     ].map((item, index) => (
//                       <motion.div
//                         key={index}
//                         whileHover={{ y: -2 }}
//                         className={`bg-gray-50 p-3 rounded-lg border border-gray-200 hover:border-[#FF8350] transition-colors ${item.colSpan === 2 ? 'col-span-2' : ''}`}
//                       >
//                         <p className="text-sm font-medium text-gray-500">{item.label}</p>
//                         <p className="text-gray-800 font-medium">{item.value || '-'}</p>
//                       </motion.div>
//                     ))}
//                   </motion.div>
//                 </motion.section>
//               ) : (
//                 <motion.p variants={slideUp}>No profile data available</motion.p>
//               )}
//             </div>
//           </motion.div>

//           {/* Preferences Information Card */}
//           <motion.div
//             initial="hidden"
//             animate="visible"
//             variants={fadeIn}
//             whileHover="hover"
//             variants={cardHover}
//             className="bg-white rounded-xl shadow-md mb-6 overflow-hidden"
//           >
//             <div className="p-4 sm:p-6 border-b border-gray-100">
//               <div className="flex items-center justify-between">
//                 <motion.h2
//                   variants={slideUp}
//                   className="text-xl sm:text-2xl font-bold text-gray-800 mb-4 flex items-center"
//                 >
//                   <span className="w-2 h-8 bg-[#FF8350] rounded-full mr-3"></span>
//                   Partner Preferences
//                 </motion.h2>
//                 <motion.button
//                   whileHover={{ scale: 1.1 }}
//                   whileTap={{ scale: 0.95 }}
//                   onClick={() => setOpenPreferenceEditForm(true)}
//                   className="p-2 rounded-md hover:bg-gray-100 transition-all"
//                 >
//                   <img src={PreferenceEditIcon} alt="Edit Preferences" className="w-6 h-6"/>
//                 </motion.button>
//               </div>

//               {loadingUserProfile ? (
//                 <motion.p variants={slideUp}>Loading Preferences...</motion.p>
//               ) : userProfile ? (
//                 <motion.div
//                   variants={fadeIn}
//                   className="grid sm:grid-cols-2 gap-4"
//                 >
//                   {[
//                     {
//                       label: "Age Range",
//                       value: `${userProfile.preferred_age_min || 'N/A'} - ${userProfile.preferred_age_max || 'N/A'} years`,
//                       type: 'range'
//                     },
//                     {
//                       label: "Height Range",
//                       value: `${userProfile.preferred_height_min || 'N/A'} - ${userProfile.preferred_height_max || 'N/A'} cm`,
//                       type: 'range'
//                     },
//                     { label: "Religion", value: userProfile.preferred_religion },
//                     { label: "Caste", value: userProfile.preferred_caste },
//                     { label: "Nakshatra", value: userProfile.preferred_nakshatra },
//                     { label: "Rashi", value: userProfile.preferred_rashi },
//                     { label: "Location", value: userProfile.preferred_location },
//                     { label: "Work Status", value: userProfile.preferred_work_status },
//                   ].map((item, index) => (
//                     <motion.div
//                       key={index}
//                       whileHover={{ y: -2 }}
//                       className="bg-gray-50 p-3 rounded-lg border border-gray-200 hover:border-[#FF8350] transition-colors"
//                     >
//                       <p className="text-sm font-medium text-gray-500">{item.label}</p>
//                       <p className="text-gray-800 font-medium">{item.value || 'Not specified'}</p>
//                     </motion.div>
//                   ))}
//                 </motion.div>
//               ) : (
//                 <motion.p variants={slideUp}>No profile data available</motion.p>
//               )}
//             </div>
//           </motion.div>

//           {/* Edit Partner Preference Modal */}
//           <AnimatePresence>
//             {openPreferenceEditForm && (
//               <motion.div
//                 className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 exit={{ opacity: 0 }}
//               >
//                 <motion.div
//                   initial={{ scale: 0.9 }}
//                   animate={{ scale: 1 }}
//                   exit={{ scale: 0.9 }}
//                   className="bg-white rounded-xl max-w-md w-full p-6 shadow-xl"
//                 >
//                   <div className="flex justify-between items-start mb-4">
//                     <h2 className="text-xl font-semibold text-gray-800">
//                       Edit Partner Preference
//                     </h2>
//                     <motion.button
//                       whileHover={{ rotate: 90 }}
//                       onClick={() => setOpenPreferenceEditForm(false)}
//                       className="p-1 rounded-lg hover:bg-gray-100 transition-colors"
//                     >
//                       <XMarkIcon className="h-5 w-5 text-gray-500" />
//                     </motion.button>
//                   </div>

//                   <form onSubmit={handleUpdatePartnerPreferences} className="space-y-4">
//                     <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                       {[
//                         { label: "Min Age", name: "preferred_age_min", type: "number" },
//                         { label: "Max Age", name: "preferred_age_max", type: "number" },
//                         { label: "Min Height (cm)", name: "preferred_height_min", type: "number" },
//                         { label: "Max Height (cm)", name: "preferred_height_max", type: "number" },
//                         { label: "Religion", name: "preferred_religion", type: "text" },
//                         { label: "Caste", name: "preferred_caste", type: "text" },
//                         { label: "Nakshatra", name: "preferred_nakshatra", type: "text" },
//                         { label: "Rashi", name: "preferred_rashi", type: "text" },
//                         { label: "Location", name: "preferred_location", type: "text", colSpan: 2 },
//                         { label: "Work Status", name: "preferred_work_status", type: "text", colSpan: 2 },
//                       ].map((field, index) => (
//                         <motion.div
//                           key={index}
//                           className={`${field.colSpan === 2 ? 'col-span-2' : ''}`}
//                           variants={slideUp}
//                         >
//                           <label className="block text-sm font-medium text-gray-700 mb-1">
//                             {field.label}
//                           </label>
//                           <motion.input
//                             type={field.type}
//                             name={field.name}
//                             value={formData[field.name]}
//                             onChange={handleChangeInputValue}
//                             className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:border-[#FF8350] focus:ring-2 focus:ring-[#FF8350]/30 transition-all outline-none"
//                             placeholder={`Enter ${field.label.toLowerCase()}`}
//                             required
//                             whileHover={inputHover.hover}
//                             whileFocus={inputHover.focus}
//                           />
//                         </motion.div>
//                       ))}
//                     </div>

//                     <div className="flex justify-end space-x-3 pt-4">
//                       <motion.button
//                         type="button"
//                         onClick={() => setOpenPreferenceEditForm(false)}
//                         whileHover={{ scale: 1.03 }}
//                         whileTap={{ scale: 0.98 }}
//                         className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
//                       >
//                         Cancel
//                       </motion.button>
//                       <motion.button
//                         type="submit"
//                         whileHover={{ scale: 1.03 }}
//                         whileTap={{ scale: 0.98 }}
//                         className="px-4 py-2 bg-[#FF8350] text-white rounded-lg hover:bg-[#E57340] transition-colors shadow-md"
//                       >
//                         Save Changes
//                       </motion.button>
//                     </div>
//                   </form>
//                 </motion.div>
//               </motion.div>
//             )}
//           </AnimatePresence>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfilePage;

// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import Sidebar from "./sidebar";
// import { Bars3Icon, GlobeAltIcon, XMarkIcon } from "@heroicons/react/24/outline";
// import { log, profile } from "@tensorflow/tfjs";
// import logoes from '../assets/Logo.png';

// import languageLogo from '../assets/Icons/language-icon-matrimony.png';

// import PreferenceEditIcon from '../assets/Icons/edit-icon.svg';
// import { useNavigate } from "react-router";

// const ProfilePage = () => {
//   const navigate = useNavigate();

//   const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);

//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);

//   const [userProfile, setUserProfile] = useState(null);
//   const [loadingUserProfile, setLoadingUserProfile] = useState(true);

//   const [openPreferenceEditForm, setOpenPreferenceEditForm] = useState(false);
//   const [formData, setFormData] = useState(null);

//   // Fetch user Profile
//   const fetchUserProfile = async () => {
//     setLoadingUserProfile(true);
//     try {
//       const token = localStorage.getItem("authToken");

//       const response = await fetch(
//         `https://backend.newbrindha.com/matrimony/my_profiles`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (response.status === 401) {
//         localStorage.removeItem("authToken");
//         return;
//       }

//       if (!response.ok) {
//         throw new Error("Failed to fetch profiles");
//       }

//       // Fetching Data
//       const data = await response.json();
//       setUserProfile(data.profile);
//     } catch (error) {
//       console.log(error.message);
//     } finally {
//       setLoadingUserProfile(false);
//     }
//   };

//   // Animation variants for modal
//   const modalVariants = {
//     hidden: { opacity: 0, scale: 0.8 },
//     visible: { opacity: 1, scale: 1, transition: { duration: 0.3 } },
//   };

//   useEffect(() => {
//     // Fetch User Profile
//     fetchUserProfile();

//     // Check for mobile/tablet view
//     const checkMobile = () => {
//       setIsMobile(window.innerWidth < 1024);
//       if (window.innerWidth >= 1024) {
//         setIsSidebarOpen(true);
//       } else {
//         setIsSidebarOpen(false);
//       }
//     };

//     checkMobile();
//     window.addEventListener("resize", checkMobile);
//     return () => window.removeEventListener("resize", checkMobile);
//   }, []);

//   const [language, setLanguage] = useState(() => {
//       const savedLanguage = localStorage.getItem("language");
//       return savedLanguage || "english"; // Default to English
//     });
//   // Updating Partner Preferences
//   const handleUpdatePartnerPreferences = async () => {

//       try {
//         const token = localStorage.getItem("authToken");

//         const response = await fetch(
//           `https://backend.newbrindha.com/matrimony/my_profiles`,
//           {
//             method: "PUT",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify(formData)
//           }
//         );

//         if (response.status === 401) {
//           localStorage.removeItem("authToken");
//           return;
//         }

//         // Get the updated data from server
//       const updatedData = await response.json();

//       // Update local state with server response
//       setFormData({
//         "preferred_age_min": updatedData.preferred_age_min || "",
//         "preferred_age_max": updatedData.preferred_age_max || "",
//         "preferred_height_min": updatedData.preferred_height_min || "",
//         "preferred_height_max": updatedData.preferred_height_max || "",
//         "preferred_religion": updatedData.preferred_religion || "",
//         "preferred_caste": updatedData.preferred_caste || "",
//         "preferred_nakshatra": updatedData.preferred_nakshatra || "",
//         "preferred_rashi": updatedData.preferred_rashi || "",
//         "preferred_location": updatedData.preferred_location || "",
//         "preferred_work_status": updatedData.preferred_work_status || ""
//       });

//         if (!response.ok) {
//           throw new Error("Failed to fetch profiles");
//         }

//       } catch (error) {
//         console.log(error.message);
//       }
//   }

//   // Fetch Partner Preferences values for Form
//   useEffect(() => {
//   if (userProfile) {
//     setFormData({
//       "preferred_age_min": userProfile.preferred_age_min || "",
//       "preferred_age_max": userProfile.preferred_age_max || "",
//       "preferred_height_min": userProfile.preferred_height_min || "",
//       "preferred_height_max": userProfile.preferred_height_max || "",
//       "preferred_religion": userProfile.preferred_religion || "",
//       "preferred_caste": userProfile.preferred_caste || "",
//       "preferred_nakshatra": userProfile.preferred_nakshatra || "",
//       "preferred_rashi": userProfile.preferred_rashi || "",
//       "preferred_location": userProfile.preferred_location || "",
//       "preferred_work_status": userProfile.preferred_work_status || ""
//     });
//   }
// }, [userProfile]);

// const handleChangeInputValue = (e) => {
//   e.preventDefault();
//   const { name, value } = e.target;
//   setFormData(prev => ({ ...prev, [name]: value }));
// }

//   // Animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: { staggerChildren: 0.2 },
//     },
//   };

//   const itemVariants = {
//     hidden: { y: 20, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: { duration: 0.5 },
//     },
//   };

//   const sidebarVariants = {
//     open: {
//       x: 0,
//       transition: {
//         type: "spring",
//         stiffness: 300,
//         damping: 30,
//       },
//     },
//     closed: {
//       x: "-100%",
//       transition: {
//         type: "spring",
//         stiffness: 300,
//         damping: 30,
//       },
//     },
//   };

//   // Handle sidebar overlay click
//   const handleOverlayClick = () => {
//     if (isMobile) {
//       setIsSidebarOpen(false);
//     }
//   };

//     // Toggle Language Dropdown
//   const toggleLanguageDropdown = () => {
//     setShowLanguageDropdown((prev) => !prev);
//   };

//   // Change Language
//   const handleLanguageChange = (lang) => {
//     setLanguage(lang);
//     setShowLanguageDropdown(false);
//   };

//   // Close language dropdown when clicking outside
//     useEffect(() => {
//       const handleClickOutside = (event) => {
//         if (showLanguageDropdown && !event.target.closest(".language-dropdown")) {
//           setShowLanguageDropdown(false);
//         }
//       };

//       document.addEventListener("mousedown", handleClickOutside);
//       return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, [showLanguageDropdown]);

//   return (
//     <div className="flex min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 font-poppins overflow-hidden relative">
//       {/* Overlay for mobile when sidebar is open */}

//       <AnimatePresence>
//         {isMobile && isSidebarOpen && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 0.5 }}
//             exit={{ opacity: 0 }}
//             onClick={handleOverlayClick}
//             className="fixed inset-0 bg-black z-30 lg:hidden"
//           />
//         )}
//       </AnimatePresence>

//       {/* Sidebar */}
//       <motion.div
//         variants={sidebarVariants}
//         initial={false}
//         animate={isSidebarOpen ? "open" : "closed"}
//         className="fixed top-0 left-0 h-full w-64 bg-gray-800 z-40 shadow-xl"
//       >
//         <Sidebar
//           isSidebarOpen={isSidebarOpen}
//           setIsSidebarOpen={setIsSidebarOpen}
//           language={language}
//           logo={logoes}
//           translations={{
//             english: {
//              // dashboard: "Dashboard",
//               home: "Home",
//               myprofile: "My Profile",
//               points: "Points",
//               favourites: "Favorites",
//               matchingProfiles: "Matching Profiles",
//               logout: "Logout",
//             },
//             tamil: {
//              // dashboard: "டாஷ்போர்டு",
//               home: "முகப்பு",
//               myprofile: "சுயவிவரம்",
//               points: "புள்ளிகள்",
//               favourites: "பிடித்தவை",
//                matchingProfiles: "பொருத்தம்",
//               logout: "வெளியேறு",
//             },
//           }}
//         />
//       </motion.div>

//       {/* Main Content */}
//       <div
//         className={`flex-1 transition-all duration-300 ${
//           isSidebarOpen ? "lg:ml-64" : "ml-0"
//         }`}
//       >

//         {/* Navbar */}
//         <motion.nav
//           initial={{ y: -100 }}
//           animate={{ y: 0 }}
//           className="fixed top-0 right-0 left-0 bg-[#FF8350] z-20"
//         >
//           <div className="flex justify-between items-center p-4">
//             <div className="flex items-center space-x-4">
//               <button
//                 onClick={() => setIsSidebarOpen(!isSidebarOpen)}
//                 className="text-gray-600 hover:text-indigo-600 transition-colors lg:hidden"
//                 aria-label="Toggle Menu"
//               >
//                 <Bars3Icon className="h-6 w-6" />
//               </button>
//               <h1 className="text-xl sm:text-2xl font-bold text-white">
//                 My Profile
//               </h1>
//             </div>

//             {/* Language Button */}
//             <div className="relative language-dropdown">
//               <button
//                 onClick={toggleLanguageDropdown}
//                 className="bg-white text-[#d35400] p-1.5 sm:p-2 rounded-full font-medium border border-[#f39c12] hover:bg-[#f39c12] hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f39c12] transition-all duration-150 ease-in-out transform hover:scale-[1.02] shadow-md"
//                 aria-label="Change Language"
//               >
//                 <img src={languageLogo} alt="language-logo" className="w-6 h-6 sm:h-6 sm:w-6 md:h-6 md:w-6" />
//               </button>

//               {/* Language Dropdown */}
//               <AnimatePresence>
//                 {showLanguageDropdown && (
//                   <motion.div
//                     initial={{ opacity: 0, y: -10 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     exit={{ opacity: 0, y: -10 }}
//                     transition={{ duration: 0.2 }}
//                     className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg border border-[#f39c12]/20 z-50"
//                   >
//                     <button
//                       onClick={() => handleLanguageChange("en")}
//                       className="w-full text-left px-4 py-2 text-[#d35400] hover:bg-[#f39c12] hover:text-white rounded-t-lg transition-colors"
//                     >
//                       English
//                     </button>
//                     <button
//                       onClick={() => handleLanguageChange("tamil")}
//                       className="w-full text-left px-4 py-2 text-[#d35400] hover:bg-[#f39c12] hover:text-white rounded-b-lg transition-colors"
//                     >
//                       தமிழ்
//                     </button>
//                   </motion.div>
//                 )}
//               </AnimatePresence>
//             </div>
//           </div>
//         </motion.nav>

//         {/* Profile Content */}
//         <motion.div
//           variants={containerVariants}
//           initial="hidden"
//           animate="visible"
//           className="p-4 sm:p-8 mt-20"
//         >
//           {/* Personal Information Card */}
//           <motion.div
//             variants={itemVariants}
//             className="bg-white rounded-xl shadow-xl mb-6 transform hover:scale-[1.01] transition-transform duration-300 hover:shadow-lg"
//           >
//             <div className="p-4 sm:p-6 border-b border-gray-100">
//               <h2 className="text-xl sm:text-[22px] font-bold text-[#5d5d5d] mb-4 flex items-center">
//                 <span className="w-2 h-8 bg-[#FF8350] rounded-full mr-3"></span>
//                 About Me
//               </h2>
//               {loadingUserProfile ? (
//                 <p>Loading profile...</p>
//               ) : userProfile ? (
//                 <section className="flex flex-col w-full h-auto">
//                  <div className="flex flex-col md:flex-row gap-4">
//                   <div className="relative w-full md:w-1/3 h-64 md:h-80 rounded-lg overflow-hidden group">
//                     <img
//                       src={userProfile.photo_path}
//                       alt={userProfile.full_name}
//                       className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
//                     />
//                     <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors duration-300"></div>
//                   </div>
//                   <div className="w-full md:w-2/3">
//                     <p className="text-justify px-4 py-4 rounded-lg outline outline-1 outline-offset-[-1px] outline-orange-600/30 hover:outline-orange-600/50 hover:bg-orange-50/30 transition-all duration-300">
//                       Hi there! I'm {userProfile.full_name}, a caring and family-oriented individual who believes in the power of love and togetherness. I'm {userProfile.age} Years Old. I enjoy the little things in life, from sharing a cup of coffee with family to taking on new adventures with someone special. I'm looking forward to meeting a partner who shares the same values, and together we can build a future filled with love and happiness.
//                     </p>
//                   </div>
//                  </div>

//                   <h2 className="text-xl sm:text-[22px] font-bold text-[#5d5d5d] mb-4 mt-6 flex items-center">
//                     <span className="w-2 h-8 bg-[#FF8350] rounded-full mr-3"></span>
//                     Personal Information
//                   </h2>

//                   <div className="grid sm:grid-cols-2 gap-3">
//                     <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal col-span-2 hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                       <span className="text-[#222] font-semibold">Matrimony ID</span>: {userProfile.matrimony_id}
//                     </div>
//                     <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                       <span className="text-[#222] font-semibold">Name</span>: {userProfile.full_name}
//                     </div>
//                     <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                       <span className="text-[#222] font-semibold">Age</span>: {userProfile.age}
//                     </div>
//                     <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                       <span className="text-[#222] font-semibold">Email</span>: {userProfile.email}
//                     </div>
//                     <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                       <span className="text-[#222] font-semibold">Phone Number</span>: {userProfile.phone_number}
//                     </div>
//                     <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                       <span className="text-[#222] font-semibold">Date of Birth</span>: {userProfile.date_of_birth}
//                     </div>
//                     <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                       <span className="text-[#222] font-semibold">Gender</span>: {userProfile.gender}
//                     </div>
//                     <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                       <span className="text-[#222] font-semibold">Occupation</span>: {userProfile.occupation}
//                     </div>
//                     <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                       <span className="text-[#222] font-semibold">Native</span>: {userProfile.native}
//                     </div>
//                   </div>
//                 </section>
//               ) : (
//                 <p>No profile data available</p>
//               )}
//             </div>
//           </motion.div>

//           {/* Preferences Information Card */}
//           <motion.div
//             variants={itemVariants}
//             className="bg-white rounded-xl shadow-xl mb-4 transform hover:scale-[1.01] transition-transform duration-300 hover:shadow-lg"
//           >
//             <div className="p-4 sm:p-6 border-b border-gray-100">
//               <div className="flex items-center justify-between">
//                 <h2 className="text-xl sm:text-2xl font-bold text-[#5d5d5d] mb-4 flex items-center">
//                   <span className="w-2 h-8 bg-[#FF8350] rounded-full mr-3"></span>
//                   Partner Preferences
//                 </h2>
//                 <button
//                   onClick={() => setOpenPreferenceEditForm(true)}
//                   className="p-2 rounded-md hover:bg-gray-200 active:bg-gray-100 transition-all duration-200 delay-50 ease-in-out w-8 h-8 sm:w-9 sm:h-9 md:w-9 md:h-9 hover:scale-110"
//                 >
//                   <img src={PreferenceEditIcon} alt="PreferenceEditIcon"/>
//                 </button>
//               </div>
//               {loadingUserProfile ? (
//                 <p>Loading Preferences...</p>
//               ) : userProfile ? (
//                 <div className="grid sm:grid-cols-2 gap-3">
//                   <div className="flex flex-wrap sm:flex-nowrap items-center justify-start gap-2 w-full">
//                     <div className="flex flex-col items-start justify-start w-full">
//                       <label className="text-[#676666] mb-1.5">Min Age</label>
//                       <div className="w-full px-2 py-2 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                         {userProfile.preferred_age_min}
//                       </div>
//                     </div>

//                     <div className="flex flex-col items-start justify-start w-full">
//                       <label className="text-[#676666] mb-1.5">Max Age</label>
//                       <div className="w-full px-2 py-2 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                         {userProfile.preferred_age_max}
//                       </div>
//                     </div>
//                   </div>

//                   <div className="flex flex-wrap sm:flex-nowrap items-center justify-start gap-2 w-full">
//                     <div className="flex flex-col items-start justify-start w-full">
//                       <label className="text-[#676666] mb-1.5">Min Height</label>
//                       <div className="w-full px-2 py-2 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                         {userProfile.preferred_height_min}
//                       </div>
//                     </div>

//                     <div className="flex flex-col items-start justify-start w-full">
//                       <label className="text-[#676666] mb-1.5">Max Height</label>
//                       <div className="w-full px-2 py-2 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                         {userProfile.preferred_height_max}
//                       </div>
//                     </div>
//                   </div>

//                   <div className="px-2 py-2 mb-1 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                     <span className="text-[#222] font-semibold">Religion</span>: {userProfile.preferred_religion}
//                   </div>
//                   <div className="px-2 py-2 mb-1 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                     <span className="text-[#222] font-semibold">Caste</span>: {userProfile.preferred_caste}
//                   </div>
//                   <div className="px-2 py-2 mb-1 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                     <span className="text-[#222] font-semibold">Nakshatra</span>: {userProfile.preferred_nakshatra}
//                   </div>
//                   <div className="px-2 py-2 mb-1 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                     <span className="text-[#222] font-semibold">Rashi</span>: {userProfile.preferred_rashi}
//                   </div>
//                   <div className="px-2 py-2 mb-1 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                     <span className="text-[#222] font-semibold">Working Location</span>: {userProfile.preferred_location}
//                   </div>
//                   <div className="px-2 py-2 mb-1 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
//                     <span className="text-[#222] font-semibold">Preferred Location</span>: {userProfile.preferred_work_status}
//                   </div>
//                 </div>
//               ) : (
//                 <p>No profile data available</p>
//               )}
//             </div>
//           </motion.div>

//           {/* Edit Partner Preference Modal */}
//           <AnimatePresence>
//             {openPreferenceEditForm && (
//               <motion.div
//                 className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
//                 initial="hidden"
//                 animate="visible"
//                 exit="hidden"
//                 variants={modalVariants}
//               >
//                 <motion.div
//                   className="bg-white rounded-xl max-w-md w-full p-6"
//                   variants={modalVariants}
//                 >
//                   <div className="flex justify-between items-start mb-4">
//                     <h2 className="text-xl font-semibold text-[#3c3c3c]">
//                       Edit Partner Preference
//                     </h2>
//                     <button
//                       onClick={() => setOpenPreferenceEditForm(false)}
//                       className="p-1 rounded-lg hover:bg-gray-100 transition-colors duration-200 hover:scale-110"
//                     >
//                       <XMarkIcon className="h-5 w-5" />
//                     </button>
//                   </div>

//                   <form onSubmit={handleUpdatePartnerPreferences} className="space-y-4">
//                     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-2 sm:gap-3">

//                     <div>
//                       <label className="block text-sm font-medium text-[#676666] mb-2">
//                         Min Age
//                       </label>
//                       <input
//                         type="number"
//                         name="preferred_age_min"
//                         value={formData.preferred_age_min}
//                         onChange={handleChangeInputValue}
//                         className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
//                         placeholder={formData.preferred_age_min}
//                         required
//                       />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-medium text-[#676666] mb-2">
//                         Max Age
//                       </label>
//                       <input
//                         type="number"
//                         name="preferred_age_max"
//                         value={formData.preferred_age_max}
//                         onChange={handleChangeInputValue}
//                         className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
//                         placeholder={formData.preferred_age_max}
//                         required
//                       />
//                     </div>

//                     <div>
//                     <label className="block text-sm font-medium text-[#676666] mb-2">
//                       Min Height
//                     </label>
//                     <input
//                       type="number"
//                       name="preferred_height_min"
//                       value={formData.preferred_height_min}
//                       onChange={handleChangeInputValue}
//                       className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
//                       placeholder={formData.preferred_height_min}
//                       required
//                     />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-medium text-[#676666] mb-2">
//                         Max Height
//                       </label>
//                       <input
//                         type="number"
//                         name="preferred_height_max"
//                          value={formData.preferred_height_max}
//                          onChange={handleChangeInputValue}
//                         className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
//                         placeholder={formData.preferred_height_max}
//                         required
//                       />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-medium text-[#676666] mb-2">
//                         Religion
//                       </label>
//                       <input
//                         type="text"
//                         name="preferred_religion"
//                         value={formData.preferred_religion}
//                         onChange={handleChangeInputValue}
//                         className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
//                         placeholder={formData.preferred_religion}
//                         required
//                       />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-medium text-[#676666] mb-2">
//                         Caste
//                       </label>
//                       <input
//                         type="text"
//                         name="preferred_caste"
//                         value={formData.preferred_caste}
//                         onChange={handleChangeInputValue}
//                         className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
//                         placeholder={formData.preferred_caste}
//                         required
//                       />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-medium text-[#676666] mb-2">
//                         Nakshatra
//                       </label>
//                       <input
//                         type="text"
//                         name="preferred_nakshatra"
//                         value={formData.preferred_nakshatra}
//                         onChange={handleChangeInputValue}
//                         className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
//                         placeholder={formData.preferred_nakshatra}
//                         required
//                       />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-medium text-[#676666] mb-2">
//                         Rashi
//                       </label>
//                       <input
//                         type="text"
//                         name="preferred_rashi"
//                         value={formData.preferred_rashi}
//                         onChange={handleChangeInputValue}
//                         className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
//                         placeholder={formData.preferred_rashi}
//                         required
//                       />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-medium text-[#676666] mb-2">
//                         Location
//                       </label>
//                       <input
//                         type="text"
//                         name="preferred_location"
//                         value={formData.preferred_location}
//                         onChange={handleChangeInputValue}
//                         className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
//                         placeholder={formData.preferred_location}
//                         required
//                       />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-medium text-[#676666] mb-2">
//                         Work Status
//                       </label>
//                       <input
//                         type="text"
//                         name="preferred_work_status"
//                         value={formData.preferred_work_status}
//                         onChange={handleChangeInputValue}
//                         className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
//                         placeholder={formData.preferred_work_status}
//                         required
//                       />
//                     </div>

//                     </div>
//                     <button
//                       type="submit"
//                       className="w-full px-4 py-2 bg-[#ff8350] text-white rounded-lg hover:bg-[#fb6b32] active:bg-[#ff8350] transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
//                     >
//                       Save Preferences
//                     </button>
//                   </form>
//                 </motion.div>
//               </motion.div>
//             )}
//           </AnimatePresence>

//         </motion.div>
//       </div>
//     </div>
//   );
// };

// export default ProfilePage;

import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Sidebar from "./sidebar";
import {
  Bars3Icon,
  GlobeAltIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import logoes from "../assets/Logo.png";
import languageLogo from "../assets/Icons/language-icon-matrimony.png";
import NavBar from "./navbar";
import PreferenceEditIcon from "../assets/Icons/edit-icon.svg";
import { useNavigate } from "react-router";
import Footer from "./footer";
import { useTranslation } from "react-i18next"; // Import useTranslation

const ProfilePage = () => {
  const { t, i18n } = useTranslation(); // Initialize useTranslation hook
  const navigate = useNavigate();

  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [loadingUserProfile, setLoadingUserProfile] = useState(true);
  const [isDeletingProfile, setIsDeletingProfile] = useState(false);
  const [deleteProfileModal, setDeleteProfileModal] = useState(false);
  const [profileStatus, setProfileStatus] = useState(true);
  const [profileStatusFetch, setProfileStatusFetch] = useState(true);
  const [openDeactivateForm, setOpenDeactivateForm] = useState(false);
  const [isActiveFormData, setIsActiveFormData] = useState({
    matrimony_id: "",
    reason: "",
  });
  const [language, setLanguage] = useState(i18n.language || "en");
  const [openPreferenceEditForm, setOpenPreferenceEditForm] = useState(false);
  const [openPersonalInfoEditForm, setOpenPersonalInfoEditForm] =
    useState(false);
  const [formData, setFormData] = useState(null);
  const [formDataPersonalInfo, setFormDataPersonalInfo] = useState({
    photo: "",
    full_name: "",
    age: "",
    date_of_birth: "",
    gender: "",
    blood_group: "",
    occupation: "",
    annual_income: "",
    mother_tongue: "",
    address: "",
    native: "",
    company: "",
    work_location: "",
    work_country: "",
    education: "",
    height: "",
    weight: "",
    religion: "",
    caste: "",
    sub_caste: "",
    nakshatra: "",
    quarter: "",
    rashi: "",
    birth_time: "",
    birth_place: "",
    ascendent: "",
    dhosham: "",
    father_name: "",
    mother_name: "",
    father_occupation: "",
    mother_occupation: "",
  });

  // Fetch user Profile
  const fetchUserProfile = async () => {
    setLoadingUserProfile(true);
    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(
        `https://backend.newbrindha.com/matrimony/my_profiles`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 401) {
        localStorage.removeItem("authToken");
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch profiles");
      }

      // Fetching Data
      const data = await response.json();
      setUserProfile(data.profile);
      console.log(data);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoadingUserProfile(false);
    }
  };

  // Sync language changes with i18next
  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "en";
    i18n.changeLanguage(savedLanguage);
    setLanguage(savedLanguage);
  }, [i18n]);

  useEffect(() => {
    // Fetch User Profile
    fetchUserProfile();

    // Check for mobile/tablet view
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
      if (window.innerWidth >= 1024) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
      }
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Updating Partner Preferences
  const handleUpdatePartnerPreferences = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("authToken");
      const formDataPayload = new FormData();

      // Append all fields to formData
      Object.entries(formData).forEach(([key, value]) => {
        formDataPayload.append(key, value);
      });

      const response = await fetch(
        `https://backend.newbrindha.com/matrimony/my_profiles`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formDataPayload,
        },
      );

      if (!response.ok) {
        throw new Error("Failed to update preferences");
      }

      // Refresh data
      await fetchUserProfile();
      setOpenPreferenceEditForm(false);

      // // // Add user feedback here
      //  alert("Preferences updated successfully!");
    } catch (error) {
      console.error("Update failed:", error);
      //alert("Update failed: " + error.message);
    }
  };

  // Fetch Partner Preferences values for Form
  useEffect(() => {
    if (userProfile) {
      setFormData({
        preferred_age_min: userProfile.preferred_age_min || "",
        preferred_age_max: userProfile.preferred_age_max || "",
        preferred_height_min: userProfile.preferred_height_min || "",
        preferred_height_max: userProfile.preferred_height_max || "",
        preferred_religion: userProfile.preferred_religion || "",
        preferred_caste: userProfile.preferred_caste || "",
        preferred_nakshatra: userProfile.preferred_nakshatra || "",
        preferred_rashi: userProfile.preferred_rashi || "",
        preferred_location: userProfile.preferred_location || "",
        preferred_work_status: userProfile.preferred_work_status || "",
      });
    }
  }, [userProfile]);

  const handleChangeInputValuePartnerPreferences = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Updating Personal Information
  const handleUpdatePersonalInformation = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("authToken");
      const formDataInfo = new FormData();

      // Append all fields to formData
      Object.entries(formDataPersonalInfo).forEach(([key, value]) => {
        if (key === "photo" && typeof value !== "string") {
          // Handle file upload
          if (value) formDataInfo.append(key, value);
        } else {
          formDataInfo.append(key, value);
        }
      });

      const response = await fetch(
        `https://backend.newbrindha.com/matrimony/my_profiles`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formDataInfo,
        },
      );

      if (response.status === 401) {
        localStorage.removeItem("authToken");
        return;
      }

      // Get the updated data from server
      const result = await response.json();

      if (!response.ok) {
        throw new Error("Failed to update profiles");
      }

      const updatedProfile = result.profile; // Access the nested profile
      setUserProfile(updatedProfile);

      // Update local state with server response
      setFormDataPersonalInfo({
        photo: updatedProfile.photo || "",
        full_name: updatedProfile.full_name || "",
        age: updatedProfile.age || "",
        date_of_birth: updatedProfile.date_of_birth || "",
        gender: updatedProfile.gender || "",
        blood_group: updatedProfile.blood_group || "",
        occupation: updatedProfile.occupation || "",
        annual_income: updatedProfile.annual_income || "",
        mother_tongue: updatedProfile.mother_tongue || "",
        address: updatedProfile.address || "",
        native: updatedProfile.native || "",
        company: updatedProfile.company || "",
        work_location: updatedProfile.work_location || "",
        work_country: updatedProfile.work_country || "",
        education: updatedProfile.education || "",
        height: updatedProfile.height || "",
        weight: updatedProfile.weight || "",
        religion: updatedProfile.religion || "",
        caste: updatedProfile.religion || "",
        sub_caste: updatedProfile.sub_caste || "",
        nakshatra: updatedProfile.nakshatra || "",
        quarter: updatedProfile.quarter || "",
        rashi: updatedProfile.rashi || "",
        birth_time: updatedProfile.birth_time || "",
        birth_place: updatedProfile.birth_place || "",
        ascendent: updatedProfile.ascendent || "",
        dhosham: updatedProfile.dhosham || "",
        father_name: updatedProfile.father_name || "",
        mother_name: updatedProfile.mother_name || "",
        father_occupation: updatedProfile.father_occupation || "",
        mother_occupation: updatedProfile.mother_occupation || "",
      });

      if (response.ok) {
        setOpenPersonalInfoEditForm(false);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleChangeInputValuePersonalInformation = (e) => {
    const { name, value } = e.target;
    setFormDataPersonalInfo((prev) => ({ ...prev, [name]: value }));
  };

  // Fetch Personal Information values for Form
  useEffect(() => {
    if (userProfile) {
      setFormDataPersonalInfo({
        photo: userProfile.photo || "",
        full_name: userProfile.full_name || "",
        age: userProfile.age || "",
        date_of_birth: userProfile.date_of_birth || "",
        gender: userProfile.gender || "",
        blood_group: userProfile.blood_group || "",
        occupation: userProfile.occupation || "",
        annual_income: userProfile.annual_income || "",
        mother_tongue: userProfile.mother_tongue || "",
        address: userProfile.address || "",
        native: userProfile.native || "",
        company: userProfile.company || "",
        work_location: userProfile.work_location || "",
        work_country: userProfile.work_country || "",
        education: userProfile.education || "",
        height: userProfile.height || "",
        weight: userProfile.weight || "",
        religion: userProfile.religion || "",
        caste: userProfile.caste || "",
        sub_caste: userProfile.sub_caste || "",
        nakshatra: userProfile.nakshatra || "",
        quarter: userProfile.quarter || "",
        rashi: userProfile.rashi || "",
        birth_time: userProfile.birth_time || "",
        birth_place: userProfile.birth_place || "",
        ascendent: userProfile.ascendent || "",
        dhosham: userProfile.dhosham || "",
        father_name: userProfile.father_name || "",
        mother_name: userProfile.mother_name || "",
        father_occupation: userProfile.father_occupation || "",
        mother_occupation: userProfile.mother_occupation || "",
      });
    }
  }, [userProfile]);

  // Inactive Profile
  const handleInactiveProfile = async (isActive, userProfile) => {
    try {
      const token = localStorage.getItem("authToken");

      // For Activation
      if (isActive) {
        const response = await fetch(
          `https://backend.newbrindha.com/matrimony/my_profiles/activate`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ is_active: true }),
          },
        );

        if (!response.ok) throw new Error("Activation failed");

        // Update all relevant states
        setProfileStatus(true);
        setProfileStatusFetch(true);
        setOpenDeactivateForm(false);
        return;
      }

      // For Deactivation
      const payload = {
        matrimony_id: userProfile?.matrimony_id,
        reason: isActiveFormData.reason.trim(),
      };

      if (!payload.reason) {
        throw new Error("Deactivation reason is required");
      }

      // Step 1: Submit deactivation report (if needed)
      try {
        const reportRes = await fetch(
          `https://backend.newbrindha.com/matrimony/user/deactivate-report`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          },
        );

        if (reportRes.status === 400) {
          const errorData = await reportRes.json();
          if (!errorData.message.includes("already exists")) {
            throw new Error(errorData.message);
          }
          // Continue with deactivation even if report exists
        } else if (!reportRes.ok) {
          throw new Error("Failed to submit deactivation reason");
        }
      } catch (reportError) {
        console.warn("Report submission:", reportError.message);
      }

      // Step 2: Deactivate profile
      const deactivateRes = await fetch(
        `https://backend.newbrindha.com/matrimony/my_profiles/activate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ is_active: false }),
        },
      );

      if (!deactivateRes.ok) throw new Error("Deactivation failed");

      // Update all states
      setProfileStatus(false);
      setProfileStatusFetch(false);
      setOpenDeactivateForm(false);
      setIsActiveFormData({ matrimony_id: "", reason: "" });

      // Force refresh of profile data
      await handleFetchProfileStatus();
    } catch (error) {
      console.error("Operation failed:", error.message);
      // Add user feedback here (toast/alert)
    }
  };

  // Fetch Profile Status
  const handleFetchProfileStatus = async () => {
    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(
        `https://backend.newbrindha.com/matrimony/my_profiles/activate`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch profile status");
      }

      // Fetching Data
      const data = await response.json();
      setProfileStatusFetch(data.is_active);
      console.log(profileStatusFetch);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    handleFetchProfileStatus();
  }, []);

  const handleChangeDeactiveProfileReason = (e) => {
    const { name, value } = e.target;
    setIsActiveFormData((prev) => ({ ...prev, [name]: value }));
  };

  // const [language, setLanguage] = useState(() => {
  //     const savedLanguage = localStorage.getItem("language");
  //     return savedLanguage || "english"; // Default to English
  //   });

  // Animation variants for modal
  const modalVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.3 } },
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5 },
    },
  };

  const sidebarVariants = {
    open: {
      x: 0,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 30,
      },
    },
    closed: {
      x: "-100%",
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 30,
      },
    },
  };

  // Handle sidebar overlay click
  const handleOverlayClick = () => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  };

  // Toggle Language Dropdown
  const toggleLanguageDropdown = () => {
    setShowLanguageDropdown((prev) => !prev);
  };

  // Update language and persist to localStorage
  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);
    setShowLanguageDropdown(false);
  };

  // Close language dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showLanguageDropdown && !event.target.closest(".language-dropdown")) {
        setShowLanguageDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showLanguageDropdown]);

  // Handle Delete User profile
  const handleDeleteUserProfile = async (matrimony_id) => {
    // dialog
    if (
      !window.confirm(
        "Are you sure you want to permanently delete your profile?",
      )
    ) {
      return;
    }
    // console.log(matrimony_id);

    setIsDeletingProfile(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        `https://backend.newbrindha.com/matrimony/delete-my_profiles?matrimony_id=${matrimony_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (!response.ok) {
        throw new Error("Failed to delete the profile.");
      }
      if (response.ok) {
        const data = await response.json();
        console.log("Delete successful:", data);

        // Clear local state
        setUserProfile(null);
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsDeletingProfile(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-br from-orange-100 via-violet-200 to-indigo-300 bg-[length:400%_400%] animate-gradient font-poppins overflow-hidden relative p-0">
      {/* Main Content */}
      <div className="min-h-[100dvh] flex-grow w-full">
        <header className="sticky top-0 z-50">
          <NavBar />
        </header>

        {/* Profile Content */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="px-3 pt-16 sm:px-10 mt-3"
        >
          {/* Personal Information Card */}
          <motion.div
            variants={itemVariants}
            className="bg-white rounded-xl shadow-xl mb-6 transform hover:scale-[1.01] transition-transform duration-300 hover:shadow-lg"
          >
            <div className="p-4 sm:p-6 border-b border-gray-100">
              {loadingUserProfile ? (
                <p>{t("loading")}</p>
              ) : userProfile ? (
                <div>
                  <section className="flex items-center justify-between">
                    <h2 className="text-xl sm:text-[22px] font-bold text-[#5d5d5d] mb-4 flex items-center">
                      <span className="w-2 h-8 bg-[#FF8350] rounded-full mr-3"></span>
                      {t("profileDetails.about")}
                    </h2>
                    <div className="flex items-center justify-center gap-2">
                      <div className="min-w-[80px] max-w-[100px] mb-2">
                        <select
                          name="status"
                          value={profileStatusFetch ? "active" : "deactive"}
                          onChange={(e) => {
                            const isActive = e.target.value === "active";
                            if (isActive) {
                              handleInactiveProfile(true, userProfile);
                            } else {
                              setOpenDeactivateForm(true);
                            }
                          }}
                          className={`py-1.5 px-2 rounded-lg border-2 border-gray-300 w-full text-white font-medium focus:outline-none ${
                            profileStatusFetch ? "bg-green-500" : "bg-red-500"
                          }`}
                        >
                          <option value="active" className="bg-green-500">
                            {t("profileDetails.active")}
                          </option>
                          <option value="deactive" className="bg-red-500">
                            {t("profileDetails.deactive")}
                          </option>
                        </select>
                      </div>
                      <AnimatePresence>
                        {openDeactivateForm && (
                          <motion.div
                            className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
                            initial="hidden"
                            animate="visible"
                            exit="hidden"
                            variants={modalVariants}
                          >
                            <motion.div
                              className="bg-white rounded-xl p-6 overflow-y-auto h-auto"
                              variants={modalVariants}
                            >
                              <div className="flex justify-between items-start mb-2">
                                <label className="text-[18px] font-semibold text-[#3c3c3c]">
                                  {t("profileDetails.deactivateReason")}
                                </label>
                                <button
                                  onClick={() => setOpenDeactivateForm(false)}
                                  className="p-1 rounded-lg hover:bg-gray-100 transition-colors duration-200 hover:scale-110"
                                >
                                  <XMarkIcon className="h-5 w-5" />
                                </button>
                              </div>
                              <form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  if (!isActiveFormData.reason.trim()) {
                                    console.error(
                                      t("profileDetails.reasonRequired"),
                                    );
                                    return;
                                  }
                                  handleInactiveProfile(false, userProfile);
                                }}
                                className="space-y-4"
                              >
                                <textarea
                                  name="reason"
                                  id="reason"
                                  onChange={handleChangeDeactiveProfileReason}
                                  className="w-full px-2 py-2 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300 h-[100px]"
                                ></textarea>
                                <button
                                  type="submit"
                                  className="w-full px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 active:bg-red-400 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                                >
                                  {t("profileDetails.deactivateProfile")}
                                </button>
                              </form>
                            </motion.div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                      <button
                        onClick={() =>
                          handleDeleteUserProfile(userProfile.matrimony_id)
                        }
                        className="bg-red-500 hover:bg-red-600 active:bg-red-400 px-2 py-2 rounded-lg text-white font-medium mb-2 text-[14px] sm:text-[15px] text-nowrap"
                      >
                        {t("profileDetails.deleteProfile")}
                      </button>
                    </div>
                  </section>
                  <section className="flex flex-col w-full h-auto">
                    <div className="flex flex-col md:flex-row gap-4">
                      <div className="relative w-full md:w-1/3 h-64 md:h-80 rounded-lg overflow-hidden group">
                        <img
                          src={userProfile.photo_path}
                          alt={userProfile.full_name}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors duration-300"></div>
                      </div>
                      <div className="w-full md:w-2/3">
                        <p className="text-justify px-4 py-4 rounded-lg outline outline-1 outline-offset-[-1px] outline-orange-600/30 hover:outline-orange-600/50 hover:bg-orange-50/30 transition-all duration-300">
                          {t("profileDetails.aboutDescription", {
                            full_name: userProfile.full_name,
                            age: userProfile.age,
                          })}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center justify-between">
                      <h2 className="text-xl sm:text-[22px] font-bold text-[#5d5d5d] mb-4 mt-6 flex items-center">
                        <span className="w-2 h-8 bg-[#FF8350] rounded-full mr-3"></span>
                        {t("profileDetails.editPersonalInformation")}
                      </h2>
                      <button
                        onClick={() => setOpenPersonalInfoEditForm(true)}
                        className="p-2 rounded-md hover:bg-gray-200 active:bg-gray-100 transition-all duration-200 delay-50 ease-in-out w-8 h-8 sm:w-9 sm:h-9 md:w-9 md:h-9 hover:scale-110"
                      >
                        <img
                          src={PreferenceEditIcon}
                          alt="PreferenceEditIcon"
                        />
                      </button>
                    </div>

                    <div className="grid sm:grid-cols-2 gap-3">
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal col-span-2 hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
                        <span className="text-[#222] font-semibold">
                          {t("matrimonyId")}
                        </span>
                        : {userProfile.matrimony_id}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
                        <span className="text-[#222] font-semibold">
                          {t("name")}
                        </span>
                        : {userProfile.full_name}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
                        <span className="text-[#222] font-semibold">
                          {t("age")}
                        </span>
                        : {userProfile.age}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("email")}
                        </span>
                        : {userProfile.email}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("phone")}
                        </span>
                        : {userProfile.phone_number}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("dateOfBirth")}
                        </span>
                        : {userProfile.date_of_birth}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
                        <span className="text-[#222] font-semibold">
                          {t("gender")}
                        </span>
                        : {t(`profileDetails.${userProfile.gender}`)}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
                        <span className="text-[#222] font-semibold">
                          {t("bloodGroup")}
                        </span>
                        : {userProfile.blood_group}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("occupation")}
                        </span>
                        : {userProfile.occupation}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("annualIncome")}
                        </span>
                        : {userProfile.annual_income}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("motherTongue")}
                        </span>
                        : {userProfile.mother_tongue}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("address")}
                        </span>
                        : {userProfile.address}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("native")}
                        </span>
                        : {userProfile.native}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("company")}
                        </span>
                        : {userProfile.company}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("workLocation")}
                        </span>
                        : {userProfile.work_location}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("workCountry")}
                        </span>
                        : {userProfile.work_country}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("education")}
                        </span>
                        : {userProfile.education}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
                        <span className="text-[#222] font-semibold">
                          {t("height")} (cm)
                        </span>
                        : {userProfile.height}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
                        <span className="text-[#222] font-semibold">
                          {t("weight")} (kg)
                        </span>
                        : {userProfile.weight}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("religion")}
                        </span>
                        : {userProfile.religion}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("caste")}
                        </span>
                        : {userProfile.caste}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("subCaste")}
                        </span>
                        : {userProfile.sub_caste}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("nakshatra")}
                        </span>
                        : {userProfile.nakshatra}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("quarter")}
                        </span>
                        : {userProfile.quarter}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("rashi")}
                        </span>
                        : {userProfile.rashi}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("birthTime")}
                        </span>
                        : {userProfile.birth_time}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("birthPlace")}
                        </span>
                        : {userProfile.birth_place}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("ascendent")}
                        </span>
                        : {userProfile.ascendent}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("dhosham")}
                        </span>
                        : {userProfile.dhosham}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("fatherName")}
                        </span>
                        : {userProfile.father_name}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("motherName")}
                        </span>
                        : {userProfile.mother_name}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("fatherOccupation")}
                        </span>
                        : {userProfile.father_occupation}
                      </div>
                      <div className="px-2 py-2 mb-0 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200 col-span-2 sm:col-span-1">
                        <span className="text-[#222] font-semibold">
                          {t("motherOccupation")}
                        </span>
                        : {userProfile.mother_occupation}
                      </div>
                    </div>
                  </section>
                </div>
              ) : (
                <p>{t("profileDetails.noProfileData")}</p>
              )}
            </div>
          </motion.div>

          {/* Preferences Information Card */}
          <motion.div
            variants={itemVariants}
            className="bg-white rounded-xl shadow-xl mb-4 transform hover:scale-[1.01] transition-transform duration-300 hover:shadow-lg"
          >
            <div className="p-4 sm:p-6 border-b border-gray-100">
              <div className="flex items-center justify-between">
                <h2 className="text-xl sm:text-2xl font-bold text-[#5d5d5d] mb-4 flex items-center">
                  <span className="w-2 h-8 bg-[#FF8350] rounded-full mr-3"></span>
                  {t("preferences")}
                </h2>
                <button
                  onClick={() => setOpenPreferenceEditForm(true)}
                  className="p-2 rounded-md hover:bg-gray-200 active:bg-gray-100 transition-all duration-200 delay-50 ease-in-out w-8 h-8 sm:w-9 sm:h-9 md:w-9 md:h-9 hover:scale-110"
                >
                  <img src={PreferenceEditIcon} alt="PreferenceEditIcon" />
                </button>
              </div>
              {loadingUserProfile ? (
                <p>{t("loading")}</p>
              ) : userProfile ? (
                <div className="grid sm:grid-cols-2 gap-3">
                  <div className="flex flex-wrap sm:flex-nowrap items-center justify-start gap-2 w-full">
                    <div className="flex flex-col items-start justify-start w-full">
                      <label className="text-[#676666] mb-1.5">
                        {t("preferredAgeRange")} ({t("ageFilter")})
                      </label>
                      <div className="w-full px-2 py-2 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
                        {userProfile.preferred_age_min} -{" "}
                        {userProfile.preferred_age_max}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-wrap sm:flex-nowrap items-center justify-start gap-2 w-full">
                    <div className="flex flex-col items-start justify-start w-full">
                      <label className="text-[#676666] mb-1.5">
                        {t("preferredHeightRange")} (cm)
                      </label>
                      <div className="w-full px-2 py-2 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
                        {userProfile.preferred_height_min} -{" "}
                        {userProfile.preferred_height_max}
                      </div>
                    </div>
                  </div>
                  <div className="px-2 py-2 mb-1 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
                    <span className="text-[#222] font-semibold">
                      {t("preferredReligion")}
                    </span>
                    : {userProfile.preferred_religion}
                  </div>
                  <div className="px-2 py-2 mb-1 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
                    <span className="text-[#222] font-semibold">
                      {t("preferredCaste")}
                    </span>
                    : {userProfile.preferred_caste}
                  </div>
                  <div className="px-2 py-2 mb-1 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
                    <span className="text-[#222] font-semibold">
                      {t("nakshatra")}
                    </span>
                    : {userProfile.preferred_nakshatra}
                  </div>
                  <div className="px-2 py-2 mb-1 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
                    <span className="text-[#222] font-semibold">
                      {t("rashi")}
                    </span>
                    : {userProfile.preferred_rashi}
                  </div>
                  <div className="px-2 py-2 mb-1 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
                    <span className="text-[#222] font-semibold">
                      {t("preferredLocation")}
                    </span>
                    : {userProfile.preferred_location}
                  </div>
                  <div className="px-2 py-2 mb-1 outline outline-1 outline-offset-[-1px] outline-orange-600/30 rounded-md font-normal hover:bg-orange-50/30 hover:outline-orange-600/50 transition-all duration-200">
                    <span className="text-[#222] font-semibold">
                      {t("preferredStatus")}
                    </span>
                    : {userProfile.preferred_work_status}
                  </div>
                </div>
              ) : (
                <p>{t("profileDetails.noProfileData")}</p>
              )}
            </div>
          </motion.div>

          {/* Edit Partner Preference Modal */}
          <AnimatePresence>
            {openPreferenceEditForm && (
              <motion.div
                className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
                initial="hidden"
                animate="visible"
                exit="hidden"
                variants={modalVariants}
              >
                <motion.div
                  className="bg-white rounded-xl max-w-md w-full p-6"
                  variants={modalVariants}
                >
                  <div className="flex justify-between items-start mb-4">
                    <h2 className="text-xl font-semibold text-[#3c3c3c]">
                      {t("profileDetails.editPartnerPreferences")}
                    </h2>
                    <button
                      onClick={() => setOpenPreferenceEditForm(false)}
                      className="p-1 rounded-lg hover:bg-gray-100 transition-colors duration-200 hover:scale-110"
                    >
                      <XMarkIcon className="h-5 w-5" />
                    </button>
                  </div>
                  <form
                    onSubmit={handleUpdatePartnerPreferences}
                    className="space-y-4"
                  >
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-2 sm:gap-3">
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("preferredAgeRange")} ({t("ageFilter")} Min)
                        </label>
                        <input
                          type="number"
                          name="preferred_age_min"
                          value={formData.preferred_age_min}
                          onChange={handleChangeInputValuePartnerPreferences}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formData.preferred_age_min}
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("preferredAgeRange")} ({t("ageFilter")} Max)
                        </label>
                        <input
                          type="number"
                          name="preferred_age_max"
                          value={formData.preferred_age_max}
                          onChange={handleChangeInputValuePartnerPreferences}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formData.preferred_age_max}
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("preferredHeightRange")} (Min cm)
                        </label>
                        <input
                          type="number"
                          name="preferred_height_min"
                          value={formData.preferred_height_min}
                          onChange={handleChangeInputValuePartnerPreferences}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formData.preferred_height_min}
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("preferredHeightRange")} (Max cm)
                        </label>
                        <input
                          type="number"
                          name="preferred_height_max"
                          value={formData.preferred_height_max}
                          onChange={handleChangeInputValuePartnerPreferences}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formData.preferred_height_max}
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("preferredReligion")}
                        </label>
                        <input
                          type="text"
                          name="preferred_religion"
                          value={formData.preferred_religion}
                          onChange={handleChangeInputValuePartnerPreferences}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formData.preferred_religion}
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("preferredCaste")}
                        </label>
                        <input
                          type="text"
                          name="preferred_caste"
                          value={formData.preferred_caste}
                          onChange={handleChangeInputValuePartnerPreferences}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formData.preferred_caste}
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("nakshatra")}
                        </label>
                        <input
                          type="text"
                          name="preferred_nakshatra"
                          value={formData.preferred_nakshatra}
                          onChange={handleChangeInputValuePartnerPreferences}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formData.preferred_nakshatra}
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("rashi")}
                        </label>
                        <input
                          type="text"
                          name="preferred_rashi"
                          value={formData.preferred_rashi}
                          onChange={handleChangeInputValuePartnerPreferences}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formData.preferred_rashi}
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("preferredLocation")}
                        </label>
                        <input
                          type="text"
                          name="preferred_location"
                          value={formData.preferred_location}
                          onChange={handleChangeInputValuePartnerPreferences}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formData.preferred_location}
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("preferredStatus")}
                        </label>
                        <input
                          type="text"
                          name="preferred_work_status"
                          value={formData.preferred_work_status}
                          onChange={handleChangeInputValuePartnerPreferences}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formData.preferred_work_status}
                          required
                        />
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="w-full px-4 py-2 bg-[#ff8350] text-white rounded-lg hover:bg-[#fb6b32] active:bg-[#ff8350] transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                    >
                      {t("profileDetails.savePreferences")}
                    </button>
                  </form>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Edit Personal Information Modal */}
          <AnimatePresence>
            {openPersonalInfoEditForm && (
              <motion.div
                className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
                initial="hidden"
                animate="visible"
                exit="hidden"
                variants={modalVariants}
              >
                <motion.div
                  className="bg-white rounded-xl max-w-full w-full p-6 overflow-y-auto min-h-[600px] max-h-[650px]"
                  variants={modalVariants}
                >
                  <div className="flex justify-between items-start mb-4">
                    <h2 className="text-xl font-semibold text-[#3c3c3c]">
                      {t("profileDetails.editPersonalInformation")}
                    </h2>
                    <button
                      onClick={() => setOpenPersonalInfoEditForm(false)}
                      className="p-1 rounded-lg hover:bg-gray-100 transition-colors duration-200 hover:scale-110"
                    >
                      <XMarkIcon className="h-5 w-5" />
                    </button>
                  </div>
                  <form
                    onSubmit={handleUpdatePersonalInformation}
                    className="space-y-4"
                  >
                    <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 gap-2 sm:gap-3">
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("profileDetails.photo")}
                        </label>
                        <input
                          type="file"
                          name="photo"
                          onChange={(e) => {
                            setFormDataPersonalInfo((prev) => ({
                              ...prev,
                              photo: e.target.files[0],
                            }));
                          }}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formDataPersonalInfo.photo}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("name")}
                        </label>
                        <input
                          type="text"
                          name="full_name"
                          value={formDataPersonalInfo.full_name}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formDataPersonalInfo.full_name}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("age")}
                        </label>
                        <input
                          type="number"
                          name="age"
                          value={formDataPersonalInfo.age}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.age}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("dateOfBirth")}
                        </label>
                        <input
                          type="date"
                          name="date_of_birth"
                          value={formDataPersonalInfo.date_of_birth}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formDataPersonalInfo.date_of_birth}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("gender")}
                        </label>
                        <select
                          name="gender"
                          value={formDataPersonalInfo.gender}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formDataPersonalInfo.gender}
                        >
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("bloodGroup")}
                        </label>
                        <select
                          name="blood_group"
                          value={formDataPersonalInfo.blood_group}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formDataPersonalInfo.blood_group}
                        >
                          <option value="A+">A+</option>
                          <option value="A-">A-</option>
                          <option value="B+">B+</option>
                          <option value="B-">B-</option>
                          <option value="AB+">AB+</option>
                          <option value="AB-">AB-</option>
                          <option value="O+">O+</option>
                          <option value="O-">O-</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("occupation")}
                        </label>
                        <input
                          type="text"
                          name="occupation"
                          value={formDataPersonalInfo.occupation}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formDataPersonalInfo.occupation}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("annualIncome")}
                        </label>
                        <input
                          type="text"
                          name="annual_income"
                          value={formDataPersonalInfo.annual_income}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formDataPersonalInfo.annual_income}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("motherTongue")}
                        </label>
                        <input
                          type="text"
                          name="mother_tongue"
                          value={formDataPersonalInfo.mother_tongue}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formDataPersonalInfo.mother_tongue}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("address")}
                        </label>
                        <input
                          type="text"
                          name="address"
                          value={formDataPersonalInfo.address}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formDataPersonalInfo.address}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("native")}
                        </label>
                        <input
                          type="text"
                          name="native"
                          value={formDataPersonalInfo.native}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formDataPersonalInfo.address}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("company")}
                        </label>
                        <input
                          type="text"
                          name="company"
                          value={formDataPersonalInfo.company}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formDataPersonalInfo.company}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("workLocation")}
                        </label>
                        <input
                          type="text"
                          name="work_location"
                          value={formDataPersonalInfo.work_location}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formDataPersonalInfo.work_location}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("workCountry")}
                        </label>
                        <input
                          type="text"
                          name="work_country"
                          value={formDataPersonalInfo.work_country}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formDataPersonalInfo.work_country}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("education")}
                        </label>
                        <input
                          type="text"
                          name="education"
                          value={formDataPersonalInfo.education}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formDataPersonalInfo.education}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("height")}
                        </label>
                        <input
                          type="number"
                          name="height"
                          value={formDataPersonalInfo.height}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.height}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("weight")}
                        </label>
                        <input
                          type="number"
                          name="weight"
                          value={formDataPersonalInfo.weight}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.weight}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("religion")}
                        </label>
                        <input
                          type="text"
                          name="religion"
                          value={formDataPersonalInfo.religion}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.religion}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("caste")}
                        </label>
                        <input
                          type="text"
                          name="caste"
                          value={formDataPersonalInfo.caste}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.caste}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("subCaste")}
                        </label>
                        <input
                          type="text"
                          name="sub_caste"
                          value={formDataPersonalInfo.sub_caste}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px] hover:border-orange-300"
                          placeholder={formDataPersonalInfo.sub_caste}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("nakshatra")}
                        </label>
                        <input
                          type="text"
                          name="nakshatra"
                          value={formDataPersonalInfo.nakshatra}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.nakshatra}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("quarter")}
                        </label>
                        <input
                          type="text"
                          name="quarter"
                          value={formDataPersonalInfo.quarter}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.quarter}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("rashi")}
                        </label>
                        <input
                          type="text"
                          name="rashi"
                          value={formDataPersonalInfo.rashi}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.rashi}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("birthTime")}
                        </label>
                        <input
                          type="text"
                          name="birth_time"
                          value={formDataPersonalInfo.birth_time}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.birth_time}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("birthPlace")}
                        </label>
                        <input
                          type="text"
                          name="birth_place"
                          value={formDataPersonalInfo.birth_place}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.birth_place}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("ascendent")}
                        </label>
                        <input
                          type="text"
                          name="ascendent"
                          value={formDataPersonalInfo.ascendent}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.ascendent}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("dhosham")}
                        </label>
                        <input
                          type="text"
                          name="dhosham"
                          value={formDataPersonalInfo.dhosham}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.dhosham}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("fatherName")}
                        </label>
                        <input
                          type="text"
                          name="father_name"
                          value={formDataPersonalInfo.father_name}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.father_name}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("motherName")}
                        </label>
                        <input
                          type="text"
                          name="mother_name"
                          value={formDataPersonalInfo.mother_name}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.mother_name}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("fatherOccupation")}
                        </label>
                        <input
                          type="text"
                          name="father_occupation"
                          value={formDataPersonalInfo.father_occupation}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.father_occupation}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-[#676666] mb-2">
                          {t("motherOccupation")}
                        </label>
                        <input
                          type="text"
                          name="mother_occupation"
                          value={formDataPersonalInfo.mother_occupation}
                          onChange={handleChangeInputValuePersonalInformation}
                          className="w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none hover:border-orange-300"
                          placeholder={formDataPersonalInfo.mother_occupation}
                        />
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="w-full px-4 py-2 bg-[#ff8350] text-white rounded-lg hover:bg-[#fb6b32] active:bg-[#ff8350] transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                    >
                      {t("profileDetails.saveInformation")}
                    </button>
                  </form>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
};

export default ProfilePage;
